import React from "react";
import muiTheme from "./theme/theme";
import { ThemeProvider } from "@mui/material";
import PageRoutes from "./routes/routes";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ⭐ Import your RTK Query hook
import { useGetAllRolesQuery } from "./services/auctionAPI";

const InitAPI = () => {
  // 🔥 This fetches ONCE and stores data in RTK Query cache
  useGetAllRolesQuery(undefined, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  });

  return null; // nothing to render
};

const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={muiTheme}>
        {/* 🔥 Load roles into global RTK Query cache */}
        <InitAPI />

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="light"
          bodyClassName={"toastBodyName"}
        />

        <PageRoutes />
      </ThemeProvider>
    </Provider>
  );
};

export default App;
